<template>
<div>

<NavBarBlank v-if="!loggedin"/>
<router-view  />

</div>
</template> 

<script>
import NavBarBlank from './NavBarBlank.vue'
import { mapState } from 'vuex'
export default {
    name:'HomeLanding',
        components:{
            NavBarBlank,
    }, 
    data() {
      return {
        pwtoken: '',
        pwemail: '',
        pwdealer:'',
        token:'',
      }
    },

    mounted() {
      this.token = this.$store.getters.token
      this.pwtoken = this.$route.query['token']
      this.pwemail = this.$route.query['email']
      this.pwdealer = this.$route.query['dealer']

      if (this.pwtoken !== undefined && this.pwemail !== undefined) {
        if (this.$route.name !== 'reset-password-form') {
          this.$router.push({
            name: 'reset-password-form',
            query: { token: this.pwtoken, email: this.pwemail, dealer: this.pwdealer }
          }).catch(() => {})
        }
      } else {
        if (this.$store.getters.token == '' || this.loggedin == false) {

          let url = this.$route.path.split('/');
          let link = '';

          if (url[1] !== '') {
            if (url[2] == 'reset') {
              link = this.$store.getters.branding.dealer
            } else {
              link = url[2]
            }

            if (this.$route.name !== 'systemlogin') {
              this.$router.push({ name: 'systemlogin', params: { dealer: link } }).catch(() => {})
            }
          }
        }
      }
    },

    computed: mapState(['loggedin']),

}
</script>